import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart_broken",
  "use": "heart_broken-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"heart_broken\"><path fill-rule=\"evenodd\" d=\"M5.592.862a3.62 3.62 0 0 0-3.75.881 3.7 3.7 0 0 0 0 5.192l4.313 4.341L7.44 8.388 5.58 6.53l-.475-.474.42-.525 1.477-1.847zM7.764 11.35l4.386-4.415A3.68 3.68 0 0 0 10.97.947a3.62 3.62 0 0 0-3.472.373L8.56 3.442l.214.43-.3.374-1.358 1.698 1.748 1.748.364.364-.21.47z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol